module.exports = __webpack_public_path__ + "static/media/favicon-light-mode.f1800e99.ico";